(function (w) {

    function EnquiryFormViewModel(args) {
        let self = this;

        //#region Toggles that affect displaying of fields and validation rules

        self.EnableProgress = ko.observable(false);

        self.WantsNewSmsSubscription = ko.observable(false);
        self.WantsNewSmsSubscription.subscribe(function () {
            self.RecheckInvalidKeys();
        });
        self.WantsToEditDetails = ko.observable(false);
        self.EditDetailsToggle = function () {
            let wants = !self.WantsToEditDetails();
            if (wants) {
                self.WantsToEditDetails(true);
                self.ShowAddressFields(true);
            }
            else {
                self.WantsToEditDetails(false);
            }
        };

        //#endregion

        //#region Form fields

        self.FirstName = ko.observable(args.model.FirstName).extend({
            required: { message: 'Please enter your first name' },
            pattern: {
                params: /^(?!.*@)(?!.*\(\s*at\s*\)).*$/,
                message: "Please enter a valid name"
            }
        });
        self.LastName = ko.observable(args.model.LastName).extend({
            required: { message: 'Please enter your last name' },
            pattern: {
                params: /^(?!.*@)(?!.*\(\s*at\s*\)).*$/,
                message: "Please enter a valid name"
            }
        });

        self.Email = ko.observable(args.model.Email).extend({ required: { message: 'Please enter your email' }, email: { message: 'Please enter a valid email' } });

        self.DialCodes = ko.observableArray(args.dialCodes);
        self.DialCode = ko.observable();

        self.PhoneNumberLabel = ko.pureComputed(function () {
            return self.CountryId() == '235' || self.CountryId() == '39' ? 'Cell phone number' : 'Mobile phone number';
        });
        self.CanDialCodeSubscribeToSms = ko.pureComputed(function () {
            return self.DialCode() && phoneNumberCheckService.canSubscribeToSmsDialCodes.indexOf('+' + self.DialCode().Value) >= 0;
        });
        self.TelephoneWithDialCode = ko.pureComputed(function () {
            // Avoid submitting a dial code without a phone number.
            let telephone = (self.Telephone() || '').trim();
            if (!telephone) {
                return '';
            }
            return '+' + (self.DialCode() && self.DialCode().Value ? self.DialCode().Value : '1') + ' ' + telephone;
        });
        self.ShowTelephoneHasToUnsubscribeLabel = ko.pureComputed(function () {
            return args.hasSmsSubscriptions && !self.CanDialCodeSubscribeToSms();
        });
        self.ShowTelephoneChangingLabel = ko.pureComputed(function () {
            return args.hasSmsSubscriptions && self.TelephoneWithDialCode() != args.userTelephone && !self.ShowTelephoneHasToUnsubscribeLabel();
        });
        self.ShowEmailChangingLabel = ko.pureComputed(function () {
            return args.hasEmailSubscriptions && self.Email() != args.userEmail;
        });

        self.Telephone = ko.observable(args.model.Telephone ? args.model.Telephone : '').extend({
            required: {
                message: 'Please enter your phone number',
                onlyIf: function () { return args.requireTelephone || self.WantsToEditDetails(); }
            },
            validation: {
                validator: function (val, dialCodeParam) {
                    let phoneNumber = ko.unwrap(val);
                    let dialCodeUnwrapped = ko.unwrap(dialCodeParam);
                    let dialCode = dialCodeUnwrapped && dialCodeUnwrapped.Value ? "+" + dialCodeUnwrapped.Value : "";
                    const details = phoneNumberCheckService.getPhoneNumberDetails(dialCode, phoneNumber);
                    return details.Type.indexOf("Mobile") >= 0;
                },
                params: self.DialCode,
                message: function (dialCodeParam, val) {
                    return 'Please enter a valid ' + self.PhoneNumberLabel().toLowerCase();
                },
                onlyIf: function () {
                    return self.CanDialCodeSubscribeToSms() && ((args.hasSmsSubscriptions && (args.requireTelephone || self.WantsToEditDetails())) || (self.WantsNewSmsSubscription() && (self.WantsToEditDetails() || !args.userPhoneIsMobile)));
                }
            },
            pattern: {
                params: /^[\d a-zA-Z\+\-\#\(\)\,\.\\\/]{6,30}$/,
                message: "Please enter a valid phone number",
                onlyIf: function () { return args.requireTelephone || self.WantsToEditDetails(); }
            }
        });

        self.AddressLine1 = ko.observable(args.model.Address1).extend({ required: { message: 'Please enter your address', onlyIf: function () { return args.requireAddress || (args.addressAlreadyComplete && self.WantsToEditDetails()); } } });
        self.AddressLine2 = ko.observable(args.model.Address2);
        self.Postcode = ko.observable(args.model.Postcode).extend({ required: { message: 'Please enter your full postcode', onlyIf: function () { return args.requireAddress || (args.addressAlreadyComplete && self.WantsToEditDetails()); } }, maxLength: 20 });
        self.City = ko.observable(args.model.City).extend({ required: { message: 'Please enter your address', onlyIf: function () { return args.requireAddress || (args.addressAlreadyComplete && self.WantsToEditDetails()); } } });

        self.States = ko.observableArray([]); // State dropdown options; filled in initialization method below
        self.StateIsRequired = function () { return (args.requireAddress || (args.addressAlreadyComplete && self.WantsToEditDetails())) && self.States().length; };
        self.State = ko.observable(args.model.StateId ? args.model.StateId : '').extend({ required: { onlyIf: self.StateIsRequired } });
        self.CountryId = ko.observable(args.model.CountryId);

        self.Message = ko.observable(args.model.Message);

        //#endregion

        //#region "Email already registered" check

        self.EmailAlreadyRegistered = ko.observable(false);

        self.Email.subscribe(function (val) {

            self.EmailAlreadyRegistered(false);

            let errors = ko.validation.group(self.Email);
            if (errors().length)
                return;

            if (!val)
                return;

            if (val == args.userEmail) {
                return;
            }

            $.ajax({
                url: args.emailCheckUrl,
                method: 'POST',
                data: { email: val },
                dataType: 'json'
            }).done(function (response) {
                if (val === self.Email() && response && response.registered) {
                    self.EmailAlreadyRegistered(true);
                    Cookies.set('preferences', 'username=' + val, { domain: args.cookieDomain });
                }
            });
        });

        //#endregion

        //#region Address finders

        self.ShowAddressFields = ko.observable(false); // If false, only show address finders; if true, show all fields for manual input
        self.ShowSelectedAddress = ko.observable(false); // If true, show selected address as text (no inputs)

        self.CountryId.subscribe(function () {
            self.ShowSelectedAddress(false);
            self.StateSelectedAutomatically(false);
        });

        self.AddAddressManually = function () {
            self.ShowAddressFields(true);
            self.ShowSelectedAddress(false);
            self.StateSelectedAutomatically(false);
        };

        self.ClearAddressFields = function () {
            self.AddressLine1('');
            self.AddressLine2('');
            self.City('');
            self.Postcode('');
            self.State(null);
        };

        //#region Google address search

        self.AddressAutoCompleteCountryCode = ko.observable(null); // Passed to google to narrow down the autocomplete to the selected country

        self.OnAddressAutoCompleteSelected = function (element, autoCompletedPlace) {

            // Clear the calling element value
            $(element).val('');

            let entityName = "";
            let postbox = "";
            let subpremise = "";
            let floor = "";
            let addressLineWithStreetNumber = "";
            let streetNumber = "";
            let addressLinePriority1 = "";
            let addressLinePriority2 = "";
            let addressLine1 = '';
            let addressLine2 = '';
            let city = "";
            let postcode = "";
            let stateId = "";

            // Clear all the Address Fields
            self.ClearAddressFields();

            // Get the Lat and lng of the chosen address for our own records 
            if (autoCompletedPlace.geometry) {
                self.latitude = autoCompletedPlace.geometry.location.lat();
                self.longitude = autoCompletedPlace.geometry.location.lng();
            }

            // Loop through each 
            for (let ac = 0; ac < autoCompletedPlace.address_components.length; ac++) {

                let addressComponent = autoCompletedPlace.address_components[ac];

                for (let t = 0; t < addressComponent.types.length; t++) {

                    if (addressComponent.types[t] === "point_of_interest") {
                        entityName = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "establishment") {
                        entityName = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "post_box") {
                        postbox = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "subpremise") {
                        subpremise = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "floor") {
                        floor = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "street_number") {
                        streetNumber = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "street_address") {
                        addressLineWithStreetNumber = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "route") {
                        addressLinePriority1 = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "sublocality") {
                        addressLinePriority2 = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "sublocality_level_1") {
                        addressLinePriority2 = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "neighborhood" && addressLinePriority2 === '') {
                        addressLinePriority2 = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "locality") {
                        city = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] === "postal_town") {
                        if (city !== '' && city !== addressComponent.long_name && addressLinePriority2 === '') {
                            addressLinePriority2 = city;
                        }
                        city = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] === "postal_code") {
                        postcode = addressComponent.long_name;
                    }

                    if (addressComponent.types[t].startsWith("administrative_area") || addressComponent.types[t] === "postal_town" || addressComponent.types[t] === "political") {
                        $("#stateIdSelect").find("option").each(function () {
                            if ($(this).text().toLowerCase() === addressComponent.long_name.toLowerCase()) {
                                stateId = $(this).attr("value");
                            }
                        });
                    }

                    if (addressLineWithStreetNumber !== '') {
                        addressLine1 = addressLineWithStreetNumber;
                    }
                    else if (addressLinePriority1 !== '') {
                        addressLine1 = (streetNumber !== '' ? streetNumber + ' ' : '') + addressLinePriority1;
                    }
                    if (floor !== '') {
                        addressLine1 = floor + ', ' + addressLine1;
                    }
                    if (subpremise !== '') {
                        addressLine1 = subpremise + ', ' + addressLine1;
                    }
                    if (postbox !== '') {
                        addressLine1 = postbox + ', ' + addressLine1;
                    }

                    addressLine2 = addressLinePriority2;
                    if (entityName !== '') {
                        addressLine2 = addressLine1;
                        addressLine1 = entityName;
                    }
                }
            }

            // Add First Line to the first street address line
            if (addressLine1 !== '') {
                self.AddressLine1(addressLine1);
            }

            // Add the second address line to the first address line object the first address line wasn't set for some reason. 
            // Otherwise, add a new item in the street address array
            if (addressLine2 !== '') {
                if (!self.AddressLine1()) {
                    self.AddressLine1(addressLine2);
                }
                else {
                    self.AddressLine2(addressLine2);
                }
            }

            // Set city and postcode
            self.City(city);
            self.Postcode(postcode);

            if (stateId) {
                self.StateSelectedAutomatically(true);
                self.State(stateId);
            } else {
                self.StateSelectedAutomatically(false);
            }

            if (addressLine1 !== '' && city !== '' && postcode !== '' && (!self.StateIsRequired() || stateId)) {
                // If we have all the required address fields, show the box with the selected address
                self.ShowSelectedAddress(true);
                self.ShowAddressFields(false);
            }
            else {
                // Show the address fields
                self.ShowSelectedAddress(false);
                self.ShowAddressFields(true);
            }
        };

        //#endregion

        //#endregion

        //#region Small helpers

        self.AcceptedCountryIdsForProvider = ko.observableArray(args.acceptedCountryIds);

        self.StateSelectedAutomatically = ko.observable(false); // Indicates if state was autoselected by OnAddressAutoCompleteSelected

        self.CountryFilterText = ko.observable(''); // Country dropdown filter input

        // Helper to display selected state name
        self.SelectedStateName = ko.pureComputed(function () {
            let stateId = self.State();
            let states = self.States();
            if (stateId && states && states.length) {
                for (let i = 0; i < states.length; i++) {
                    if (states[i].stateId == stateId) {
                        return states[i].stateName;
                    }
                }
            }
            return '';
        });

        self.SelectedCountryName = ko.observable('');

        // Automatically update dial code when country changes
        self.CountryId.subscribe(function (countryId) {
            if (countryId) {
                for (let i = 0; i < args.countries.length; i++) {
                    let country = args.countries[i];
                    if (country.Id == countryId) {
                        self.SelectedCountryName(country.Name);
                        break;
                    }
                }
                let dialCodes = self.DialCodes();
                if (dialCodes && dialCodes.length) {
                    for (let i = 0; i < dialCodes.length; i++) {
                        let dialCode = dialCodes[i];
                        if (dialCode.CountryId == countryId) {
                            self.DialCode(dialCode);
                            self.AddressAutoCompleteCountryCode(dialCode.CountryCode);
                            return;
                        }
                    }
                }
            }
            else {
                self.SelectedCountryName('');
            }
        });

        //#endregion

        //#region Getting states for selected country

        self.GetStates = function (countryId, retryCount, keepSelectedState) {

            if (retryCount && retryCount > 2)
                return;

            if (!countryId || countryId < 0)
                return;

            if (!keepSelectedState) {
                self.State('');
            }

            $.ajax({
                url: args.getStatesUrl.replace("1138", countryId),
                method: 'GET'
            }).done(function (response) {
                self.States(response);
                self.RecheckInvalidKeys();
            }).fail(function () {
                retryCount = retryCount || 0;
                self.GetStates(countryId, retryCount + 1, keepSelectedState);
            });
        };

        //#endregion

        //#region States and other fields initialization

        self.InitializeDialCodeAndTelephone = function (telephone) {
            let dialCodes = self.DialCodes();

            // Use the longest matching dial code so +1876 won't get split into +1 and 876...
            if (telephone && telephone.startsWith('+')) {
                let matchedDialCode = null;
                let matchedDialCodeValue = '';
                for (let i = 0; i < dialCodes.length; i++) {
                    let dialCodeValue = dialCodes[i] && dialCodes[i].Value ? dialCodes[i].Value.toString() : '';
                    let dialCodeMatchesCountry = dialCodes[i] && dialCodes[i].CountryId == self.CountryId();
                    let matchedDialCodeMatchesCountry = matchedDialCode && matchedDialCode.CountryId == self.CountryId();
                    let isLongerDialCodeMatch = dialCodeValue.length > matchedDialCodeValue.length;
                    let isCountryMatchForSameDialCode = dialCodeValue.length == matchedDialCodeValue.length && dialCodeMatchesCountry && !matchedDialCodeMatchesCountry;
                    if (dialCodeValue && telephone.startsWith('+' + dialCodeValue) && (isLongerDialCodeMatch || isCountryMatchForSameDialCode)) {
                        matchedDialCode = dialCodes[i];
                        matchedDialCodeValue = dialCodeValue;
                    }
                }
                if (matchedDialCode) {
                    self.DialCode(matchedDialCode);
                    self.Telephone(telephone.slice(('+' + matchedDialCodeValue).length).trim());
                    self.AddressAutoCompleteCountryCode(matchedDialCode.CountryCode);
                }
            }

            // Promote NANP-specific dial codes when a +1 number includes a matching area code
            let selectedDialCode = self.DialCode();
            let selectedDialCodeValue = selectedDialCode && selectedDialCode.Value ? selectedDialCode.Value.toString() : '';
            let nanpDialCodeLookup = phoneNumberCheckService.getNanpDialCodeLookup(dialCodes);
            let promotion = phoneNumberCheckService.tryPromoteNanpDialCode(selectedDialCodeValue, self.Telephone(), nanpDialCodeLookup);
            if (promotion) {
                self.DialCode(promotion.DialCode);
                self.Telephone(promotion.Telephone);
                self.AddressAutoCompleteCountryCode(promotion.DialCode.CountryCode);
            }
        };
        self.InitializeDialCodeAndTelephone(self.Telephone());

        let initialCountryId = self.CountryId();
        // Initialize states dropdown based on the country
        if (initialCountryId && initialCountryId > 0) {
            // If dial code is not selected yet, set it based on the country
            if (!self.DialCode()) {
                let dialCodeToSelect = self.DialCodes().find(function (x) { return x.CountryId == initialCountryId; });
                if (dialCodeToSelect) {
                    self.DialCode(dialCodeToSelect);
                    self.AddressAutoCompleteCountryCode(dialCodeToSelect.CountryCode);
                }
            }
            // Set States dropdown based on the country
            self.GetStates(initialCountryId, 0, true);
        }

        // Whenever Country changes, get the states for the selected country
        self.CountryId.subscribe(self.GetStates);
        
        //#endregion

        //#region Validation helpers (for 'error' class support on top of validationMessage bindings)

        self.Validateables = [
            { key: 'FirstName', value: self.FirstName },
            { key: 'LastName', value: self.LastName },
            { key: 'CountryId', value: self.CountryId },
            { key: 'Email', value: self.Email },
            { key: 'Telephone', value: self.Telephone },
            { key: 'AddressLine1', value: self.AddressLine1 },
            { key: 'AddressLine2', value: self.AddressLine2 },
            { key: 'Postcode', value: self.Postcode },
            { key: 'City', value: self.City },
            { key: 'State', value: self.State }
        ];


        // This array will hold Validateables keys (e.g. ['FirstName','LastName']) for which we can display an error
        self.InvalidKeys = ko.observableArray([]);

        // This function goes through the InvalidKeys array to check if they are still invalid
        // This is because some validateables may affect others - e.g. changing the country may affect the state dropdown.
        self.RecheckInvalidKeys = function () {
            let invalidKeys = self.InvalidKeys();
            //for each invalid key...
            for (let i = invalidKeys.length - 1; i >= 0; i--) {
                let invalidKey = invalidKeys[i];
                //find its relevant validateable...
                for (let j = 0; j < self.Validateables.length; j++) {
                    let validateable = self.Validateables[j];
                    if (validateable.key === invalidKey) {
                        //and check if it's still invalid
                        let error = ko.validation.group(validateable.value);
                        if (error().length === 0) {
                            //remove from InvalidKeys array if it's not invalid anymore
                            self.InvalidKeys.remove(validateable.key);
                        }
                    }
                }
            }
        };

        // For each validateable, add a subscription that updates InvalidKeys array when necessary:
        for (let i = 0; i < self.Validateables.length; i++) {
            let validateable = self.Validateables[i];

            validateable.value.subscribe(function (val) {
                // Whenever a validateable value is updated, check if it should be added to or removed from InvalidKeys
                let error = ko.validation.group(validateable.value);
                if (error().length === 0) {
                    self.InvalidKeys.remove(validateable.key);
                } else if (self.InvalidKeys().indexOf(validateable.key) < 0) {
                    self.InvalidKeys.push(validateable.key);
                }
                // And since they can affect each other, recheck invalid keys (maybe some became valid because of this new change)
                self.RecheckInvalidKeys();
            });
        }

        // Each key also gets their own pureComputed to check if there's an error with it. Usage: data-bind="visible: IsInvalid('FirstName')()"
        self.IsInvalid = function (key) {
            return ko.pureComputed(function () { return self.InvalidKeys().indexOf(key) >= 0; });
        };

        //#endregion

        //#region Form submit

        self.IsFormSubmitting = ko.observable(false);
        self.TrySubmit = function () {

            // When submitting, check if there are any errors first:

            // Refresh InvalidKeys array (to display correct error classes)
            for (let i = 0; i < self.Validateables.length; i++) {
                let validateable = self.Validateables[i];
                let error = ko.validation.group(validateable.value);
                if (error().length === 0) {
                    self.InvalidKeys.remove(validateable.key);
                } else if (self.InvalidKeys().indexOf(validateable.key) < 0) {
                    self.InvalidKeys.push(validateable.key);
                }
            }

            // Do validation
            let errors = ko.validation.group(self);
            if (errors().length) {

                // Show all errors messages, then scroll to first error
                errors.showAllMessages();
                setTimeout(function () {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $(".error").first().offset().top
                    }, 1000);
                }, 100);

                // Don't submit form
                return false;
            }

            // No errors, so return true to submit form:
            return true;
        };

        //#endregion
    }
    w.enquiryFormViewModel = EnquiryFormViewModel;
})(window);
